<div class="modal-header">
  <h4 class="modal-title">{{ modalTitle }}</h4>
  <button *ngIf="hasCloseButtonAtHeader !== false" type="button" class="close" aria-label="Close" (click)="onCancelClick()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div *ngIf="videoUrl && !errorMessage" class="video-wrapper">
    <video
      #videoElement
      (click)="onVideoError"
      width="{{ videoWidth }}"
      height="{{ videoHeight }}"
      controls
      type="video/webm"
    ></video>
  </div>
  <div *ngIf="!videoUrl" class="error-message">Error: Video URL has not been configured</div>
  <div *ngIf="errorMessage" class="error-message">Error: {{ errorMessage }}</div>
  <div class="actions">
    <button *ngIf="hasCloseButtonAtBody !== false" type="button" class="btn btn-default" aria-label="Close" (click)="onCancelClick()">
      <span i18n="generic button label to cancel or close|A generic button label to close or cancel a form without saving nor submitting the changes@@genericCloseButton">Close</span>
    </button>
  </div>
</div>
